if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            
            if (!this.productElement) {
                console.error('Quick Add: Main product section not found in fetched content.');
                return;
            }

            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            // *** ОСНОВНА ЗМІНА: ВИКЛИКАЄМО ІНІЦІАЛІЗАЦІЮ СКРИПТІВ ТУТ ***
            this._initializeProductLogic(this.modalContent);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      // *** НОВИЙ МЕТОД ДЛЯ ІНІЦІАЛІЗАЦІЇ JS-ЛОГІКИ ТОВАРУ ***
      _initializeProductLogic(container) {
        // 1. Accordion Logic
        const triggers = container.querySelectorAll('.maison_commerce-faq-item-trigger');
        triggers.forEach(trigger => {
          trigger.addEventListener('click', (event) => {
            const clickedTrigger = event.currentTarget;
            const content = clickedTrigger.nextElementSibling;
            const icon = clickedTrigger.querySelector('.maison_commerce-faq-item-trigger-icon');

            triggers.forEach(otherTrigger => {
              if (otherTrigger !== clickedTrigger) {
                otherTrigger.nextElementSibling.classList.remove('active');
                otherTrigger.querySelector('.maison_commerce-faq-item-trigger-icon').classList.remove('active');
              }
            });

            content.classList.toggle('active');
            icon.classList.toggle('active');
          });
        });

        // 2. Recommendations Slider Logic
        const initRecommendationsSlider = () => {
          const sliderEl = container.querySelector('[class*="recommendations-slider-"]');
          if (sliderEl && typeof Swiper !== 'undefined') {
            new Swiper(sliderEl, {
              loop: true,
              slidesPerView: 2,
              spaceBetween: 8,
              navigation: {
                nextEl: container.querySelector('[class*="recommendations-arrow-next-"]'),
                prevEl: container.querySelector('[class*="recommendations-arrow-prev-"]'),
              },
              breakpoints: {
                320: { slidesPerView: 2, spaceBetween: 8 },
                768: { slidesPerView: 2, spaceBetween: 8 }
              }
            });
          }
        };
        setTimeout(initRecommendationsSlider, 500);

        // 3. Product Gallery Slider Logic (Mobile only)
        let gallerySwiper;
        const gallerySliderElement = container.querySelector('[class*="product-gallery-slider-"]');
        if (gallerySliderElement && typeof Swiper !== 'undefined') {
            const mediaQuery = window.matchMedia('(max-width: 991.98px)');

            const handleGallerySlider = (e) => {
                if (e.matches) {
                    if (!gallerySwiper || gallerySwiper.destroyed) {
                        gallerySwiper = new Swiper(gallerySliderElement, {
                            slidesPerView: 'auto',
                            spaceBetween: 7,
                            centeredSlides: false,
                            loop: false,
                            navigation: {
                                nextEl: container.querySelector('[class*="gallery-arrow-next-"]'),
                                prevEl: container.querySelector('[class*="gallery-arrow-prev-"]'),
                            },
                            pagination: {
                                el: container.querySelector('[class*="gallery-pagination-"]'),
                                clickable: true,
                                type: 'bullets',
                            },
                        });
                    }
                } else {
                    if (gallerySwiper && !gallerySwiper.destroyed) {
                        gallerySwiper.destroy(true, true);
                        gallerySwiper = undefined;
                    }
                }
            };
            
            mediaQuery.addEventListener('change', handleGallerySlider);
            handleGallerySlider(mediaQuery);
        }

        // 4. Size Chart Popup Logic
        // Важливо: у вашому HTML-коді ID для таблиці розмірів мають бути унікальними
        // або використовуйте класи для уникнення конфліктів.
        const openTrigger = container.querySelector('#open-size-chart');
        const closeTrigger = container.querySelector('#close-size-chart');
        const overlay = container.querySelector('#size-chart-overlay');
        const popup = container.querySelector('#size-chart-popup');

        if (openTrigger && closeTrigger && overlay && popup) {
          const openPopup = () => {
            overlay.classList.add('active');
            popup.classList.add('active');
          };

          const closePopup = () => {
            overlay.classList.remove('active');
            popup.classList.remove('active');
          };

          openTrigger.addEventListener('click', openPopup);
          closeTrigger.addEventListener('click', closePopup);
          overlay.addEventListener('click', closePopup);
          
          // Слухач на Esc залишається на document, це нормально
          document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape' && popup.classList.contains('active')) {
              closePopup();
            }
          });
        }
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;
        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();
        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();
        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        if (!product) return;
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}

